import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(name, state, regionId, enabled) {
  return yield oncallFetch("/api/oncall/partners/cities/add", {
    name,
    state,
    regionId,
    enabled,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/cities/add.js